import { useEffect } from "react";

type UseMapInteractionToggleProps = {
    map: mapboxgl.Map | null;
    isDragging: boolean;
};

/**
 * Enables/disables map interactions (pan, zoom) based on drag state
 */
export function useMapInteractionToggle({ map, isDragging }: UseMapInteractionToggleProps) {
    useEffect(() => {
        if (!map) return;

        if (isDragging) {
            // Disable map interactions during drag
            map.dragPan.disable();
            map.doubleClickZoom.disable();
            map.scrollZoom.disable();
        } else {
            // Re-enable map interactions
            map.dragPan.enable();
            map.doubleClickZoom.enable();
            map.scrollZoom.enable();
        }

        return () => {
            // Cleanup: ensure interactions are re-enabled
            if (map) {
                map.dragPan.enable();
                map.doubleClickZoom.enable();
                map.scrollZoom.enable();
            }
        };
    }, [map, isDragging]);
}
